import React from 'react';
import {
  Box,
  Paper,
  Typography,
} from '@mui/material';
import { env } from '../utils/env';

const Footer: React.FC = () => {
  // Estilos do Footer
  const footerStyles = {
    mt: 'auto',
    py: {
      xs: 1.5, // Mobile: padding menor
      sm: 2, // Desktop: padding padrão
    },
    px: {
      xs: 2, // Mobile: padding lateral menor
      sm: 3, // Desktop: padding padrão
    },
    borderTop: 1,
    borderColor: 'divider',
    backgroundColor: 'background.paper',
    display: {
      xs: 'none',
      md: 'block',
    },
  };

  return (
    <Paper
      component="footer"
      elevation={0}
      sx={footerStyles}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: {
            xs: 1, // Mobile: gap menor
            sm: 2, // Desktop: gap padrão
          },
          // Em mobile, empilhar verticalmente
          flexDirection: {
            xs: 'column',
            sm: 'row',
          },
          textAlign: {
            xs: 'center',
            sm: 'left',
          },
        }}
      >
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{
            fontSize: {
              xs: '0.75rem', // Mobile: texto menor
              sm: '0.875rem', // Desktop: texto padrão
            },
          }}
        >
          © 2025 SysUp - Sistema de Gerenciamento ISP
        </Typography>
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{
            fontSize: {
              xs: '0.75rem', // Mobile: texto menor
              sm: '0.875rem', // Desktop: texto padrão
            },
            // Esconder em telas muito pequenas
            display: {
              xs: 'none',
              sm: 'block',
            },
          }}
        >
          Versão {env.APP_VERSION} | Desenvolvido com ❤️ para ISPs brasileiros
        </Typography>
      </Box>
    </Paper>
  );
};

export default Footer; 